import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import themes from 'themes';

// ==============================|| MINIMAL LAYOUT ||============================== //
//
// Wraps all public/auth pages (landing, staff login, customer login,
// forgot/reset password, privacy policy) in a forced LIGHT ThemeProvider so
// these pages always render in light mode regardless of the user's chosen
// in-app dark/light preference. The toggle only affects the authenticated
// dashboard via MainLayout.

const MinimalLayout = () => {
    const customization = useSelector((state) => state.customization);
    // Override navType to 'light' for all children of this layout.
    const lightTheme = themes({ ...customization, navType: 'light' });

    return (
        <ThemeProvider theme={lightTheme}>
            <Outlet />
        </ThemeProvider>
    );
};

export default MinimalLayout;
